export default function makeAlias(alias) {
  if (alias) {
    return `https://${alias}`;
  }
  return '';
}
